module.exports = __webpack_public_path__ + "static/media/architectwork.fcdc9f6b.jpg";